module.exports = __webpack_public_path__ + "img/logo-head.f7de1eea.png";